<div class="admins-root" *transloco="let t">
  <app-search [control]="search" (searchClick)="getAdmins()"></app-search>
  <app-filter-container
    (selectFilterClick)="updateFilter($event)"
    [filters]="this.filters"
    [regions]="this.regions"
    [baseSimpleChipData]="chips"
    *ngIf="showFilter"
  ></app-filter-container>
  <div class="header">
    <div class="name">
      {{ labels.name }}
    </div>
    <span>{{ labels.region }}</span>
    <span>{{ labels.accessLevel }}</span>
  </div>
  <div class="divider"></div>
  <div
    class="admins-list"
    *ngIf="feedItems.length && !loading"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    [scrollWindow]="false"
    [immediateCheck]="true"
    (scrolled)="pullAdmins()"
  >
    <div *ngFor="let item of feedItems">
      <app-admin-list-item
        [admin]="item"
        (itemChanged)="handleItemChange($event)"
      ></app-admin-list-item>
    </div>
    <div class="loading-more-items">
      <mat-spinner diameter="15" *ngIf="pulling"></mat-spinner>
    </div>
    <div *ngIf="loading" class="loading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </div>
  <div class="admins-list" *ngIf="feedItems.length === 0 && loading">
    <div *ngFor="let item of mockFeedItems">
      <app-admin-list-item
        [admin]="item"
        (itemChanged)="handleItemChange($event)"
      ></app-admin-list-item>
    </div>
    <div class="loading-more-items">
      <mat-spinner diameter="15" *ngIf="pulling"></mat-spinner>
    </div>
    <div *ngIf="loading" class="loading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </div>
  <div *ngIf="feedItems.length === 0 && !loading" class="no-items">
    <nb-icon icon="people-outline"></nb-icon>
    <h2>{{ t('empty-control-panel') }}</h2>
    <div>{{ t('empty-control-panel-2') }}</div>
  </div>
</div>
